var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.333,
    height: 16.757,
    viewBox: "0 0 22.333 16.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-request",
    transform: "translate(-1263.5 -48.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M23.588,6A1.4,1.4,0,0,0,23.3,6H3.76a1.4,1.4,0,0,0-.37.056L13.475,16.1Z",
    transform: "translate(1261.129 42.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M24.18,7.39,14.018,17.51a1.4,1.4,0,0,1-1.968,0L1.979,7.467a1.4,1.4,0,0,0-.049.349V21.774a1.4,1.4,0,0,0,1.4,1.4H22.867a1.4,1.4,0,0,0,1.4-1.4V7.816A1.4,1.4,0,0,0,24.18,7.39ZM4.282,21.774h-.97v-1l5.074-5.032.984.984Zm18.572,0h-.977l-5.088-5.046.984-.984,5.074,5.032Z",
    transform: "translate(1261.57 42.209)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequest);
export default __webpack_public_path__ + "static/media/icon-request.802aaf97e2bdfb4e57056448b21830b0.svg";
export { ForwardRef as ReactComponent };